import { useState } from "react";
import { FaCaretRight, FaStopCircle } from "react-icons/fa";
import { PiStarFourFill } from "react-icons/pi";
import { Link, useLocation } from "react-router";

import { useChainId } from "wagmi";

import { useTotalBalance } from "entities/balance/use-total-balance";
import { CurrencyCardWithBalance } from "entities/currency";
import { PointsLeaderboardCard } from "entities/points";
import { WasabiPointsCard } from "entities/points/wasabi-points-card";
import { bentoUSDConfig, bentoUSDPlusConfig } from "shared/config/const";
import { Button } from "shared/ui/button";
import { Tab, Tabs } from "shared/ui/tabs";

import { Header } from "./header";

export const WalletDrawer = () => {
  const location = useLocation();
  const isPortfolioPage = location.pathname.includes("/portfolio");
  const [activeTab, setActiveTab] = useState<"assets" | "points">("assets");
  const chainId = useChainId();
  const bento = bentoUSDConfig[chainId];
  const bentoPlus = bentoUSDPlusConfig[chainId];

  const totalBalance = useTotalBalance();

  return (
    <div
      style={{
        boxShadow:
          "0px 12px 34.5px 0px #0000004D, 0px 1px 1px 0px #FFFFFF1A inset",
      }}
      className="bg-baltic-sea/30 flex grow flex-col pb-3.5 backdrop-blur-[220px]"
    >
      <Header />
      <div className="flex grow flex-col px-5 py-7.5">
        <div className="text-nobel/70 leading-[150%]">Total balance</div>
        <div className="mt-2.5 flex text-[42px] leading-[115%]">
          {totalBalance ?? 0}
        </div>

        <Tabs className="mx-auto mt-9 w-full gap-x-1.5 rounded-xl">
          <Tab
            onClick={() => {
              setActiveTab("assets");
            }}
            isActive={activeTab === "assets"}
            className="w-full rounded-md"
          >
            <FaStopCircle className="rotate-45" /> Assets
          </Tab>
          <Tab
            onClick={() => {
              setActiveTab("points");
            }}
            isActive={activeTab === "points"}
            className="w-full rounded-md"
          >
            <PiStarFourFill /> Points
          </Tab>
        </Tabs>

        <div className="mt-3.5 flex grow flex-col gap-2">
          {activeTab === "assets" && (
            <>
              <CurrencyCardWithBalance
                currency={bento}
                link="https://HARDCODE"
              />
              <CurrencyCardWithBalance
                style={{
                  backgroundImage: `
                    linear-gradient(0deg, rgba(41, 41, 41, 0.3), rgba(41, 41, 41, 0.3)), radial-gradient(310.86% 310.86% at 18.38% -199.39%, rgba(34, 237, 78, 0.3) 0%, rgba(34, 237, 78, 0) 100%)
                  `,
                }}
                currency={bentoPlus}
                link="https://HARDCODE"
              />
            </>
          )}

          {activeTab === "points" && (
            <>
              <WasabiPointsCard />
              <PointsLeaderboardCard />
            </>
          )}

          {!isPortfolioPage && (
            <Button
              to="/portfolio"
              className="mt-auto self-center pr-15"
              as={Link}
            >
              View Profile
              <Button.Icon className="size-6.5 bg-white/10 px-2.5 py-2">
                <FaCaretRight />
              </Button.Icon>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
